import PropTypes from 'prop-types'
import React, { Component } from 'react'
import BundleTrackerMark from 'desktop/components/layout/bundle_tracker_mark'
import BundleMessage from 'base/components/products/bundle_message'

const bundleShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  threshold_count: PropTypes.number.isRequired,
  discounted_price_per_unit: PropTypes.number.isRequired,
})

class BundleTracker extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    currencySymbol: PropTypes.string.isRequired,
    originalPrice: PropTypes.number.isRequired,
    lineItemCount: PropTypes.number.isRequired,
    bundle: bundleShape.isRequired,
  }

  render() {
    const threshold = this.props.bundle.threshold_count
    const totalToDisplay = Math.min(this.props.bundle.threshold_count, this.props.lineItemCount)

    const countCopy =
      this.props.lineItemCount > this.props.bundle.threshold_count
        ? this.props.lineItemCount
        : `${totalToDisplay} of ${this.props.bundle.threshold_count}`

    return (
      <div className="bundle-tracker">
        <div className="bundle-tracker__info">
          <span className="bundle-tracker__title">{this.props.title}</span>
          <span className="bundle-tracker__added">
            <span className="bundle-tracker__count">{countCopy}</span> added
          </span>
        </div>

        <div className="bundle-tracker__progress">
          {Array(threshold)
            .fill(null)
            .map((_space, index) => {
              const components = []

              components.push(
                <BundleTrackerMark
                  key={`mark-${index}`}
                  showLeftDivider={index > 0}
                  showRightDivider
                  rightDividerColor={index + 1 >= threshold ? '#ffffff' : null}
                  isComplete={index < this.props.lineItemCount}
                />,
              )

              if (index + 1 < threshold) {
                components.push(
                  <div key={`divider-${index}`} className="bundle-tracker__progress-divider" />,
                )
              }

              return components
            })}
        </div>

        <div className="bundle-tracker__cta">
          <BundleMessage
            currentBundle={this.props.bundle}
            currencySymbol={this.props.currencySymbol}
            originalPrice={this.props.originalPrice}
          />
        </div>
      </div>
    )
  }
}

export default BundleTracker
